import { Text } from '@mxenabled/mxui'

import Stack from '@mui/material/Stack'
import { type SxProps } from '@mui/material/styles'

interface DoubleBarChartLegendProps {
  comparisonColor: string
  legendLabelComparison?: string
  legendLabelMain?: string
  legendStyle?: SxProps
  mainColor: string
}

export const DoubleBarChartLegend = ({
  comparisonColor,
  legendLabelComparison,
  legendLabelMain,
  legendStyle = {},
  mainColor,
}: DoubleBarChartLegendProps) => (
  <Stack
    sx={{
      alignItems: 'center',
      flexDirection: 'row',
      gap: 16,
      justifyContent: 'flex-end',
      width: '100%',
      ...legendStyle,
    }}
  >
    {legendLabelMain && (
      <Stack alignItems="center" flexDirection="row" gap={8}>
        <svg
          aria-hidden="true"
          aria-labelledby="legendMain"
          fill="none"
          height="6"
          role="figure"
          width="7"
        >
          <rect fill={mainColor} height="6" rx="2" width="6" x="0.4375" />
        </svg>
        <Text id="legendMain" sx={{ fontSize: 11, fontWeight: 400 }} variant="caption">
          {legendLabelMain}
        </Text>
      </Stack>
    )}
    {legendLabelComparison && (
      <Stack alignItems="center" flexDirection="row" gap={8}>
        <svg
          aria-hidden="true"
          aria-labelledby="legendComparison"
          fill="none"
          height="6"
          role="figure"
          width="7"
        >
          <rect fill={comparisonColor} height="6" rx="2" width="6" x="0.4375" />
        </svg>
        <Text id="legendComparison" sx={{ fontSize: 11, fontWeight: 400 }} variant="caption">
          {legendLabelComparison}
        </Text>
      </Stack>
    )}
  </Stack>
)
